import { render } from "./SVGSave.vue?vue&type=template&id=e160f5a0"
import script from "./SVGSave.vue?vue&type=script&lang=js"
export * from "./SVGSave.vue?vue&type=script&lang=js"

import exportComponent from "/Users/vladimirkurockin/Projects/NowMedia/wardrobe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__